/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  $(".custom-marketing-form").submit(function (e) {
  e.preventDefault();
  var redirectPage = $(this).data("redirect");
      var data = $(this).serialize();
      var notice = $(this).find(".form-notice");
  var settings = {
    async: true,
    crossDomain: true,
    url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache"
    },

    data: data
  };
  $.ajax(settings).done(function (response) {
    var res = response.data.is_subscribed;
    console.log(res);
    if (res) {
        $(notice).html("You are already subscribed!");
    } else {
      window.location.replace(
        redirectPage
      );
    }
  });
});


$(".custom-marketing-form-v2").submit(function (e) {
  e.preventDefault();
  var redirectPage = $(this).data("redirect");
      var data = $(this).serialize();
  var notice = $(this).find(".form-notice");
  
  var settings = {
    async: true,
    crossDomain: true,
    url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache"
    },

    data: data
  };
  $.ajax(settings).done(function (response) {
    var res = response.data.is_subscribed;
    console.log(res);
    if (res) {
        $(notice).html("You are already subscribed!");
    } else {
      window.location.replace(
        window.location + "?thank-you"
      );
    }
  });
});
if (window.location.search.includes("thank-you")) {
  $(".form-stage-2").addClass("form-submitted");
  $(".custom-marketing-form-v2").addClass("form-submitted");
}
$(document).ready(function () {
  $("#articleProducts").flickity({
"prevNextButtons": true,
"pageDots": false,
"wrapAround": false,
"contain": true,
"cellAlign": "center",
"watchCSS": true,
"dragThreshold": 8,
"groupCells": true,
"arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});
});


if ($("#articleProducts").find(".Carousel__Cell").length == '0') {
  $("#shopify-section-article-products").find('section').remove()
}

if (document.getElementById("click1")) {
  // document.getElementById("click1").addEventListener("click", (() > {

  //   console.log("clicked")
  // }))
}